module.exports = __webpack_public_path__ + "static/LucasPope2-6a1947d0c55741b15d3af82fa2d4c409.webp";